<template>
  <v-snackbar
    v-model="genericErrorDialog"
    color="info"
    right
    class="snackbarError"
    multi-line
    vertical
    :timeout='18000'
  >
    <v-layout justify-center align-center column>
      <v-layout row>
        <v-icon style="margin-top: -0.71em; margin-right: 0.5em;" dark medium>warning</v-icon>
        <h2>Not so Super ..Linda!</h2>
      </v-layout>
      <h4 class="headline_error_2">{{errorMessage}}</h4>
      <i style="font-size:10px">{{contactHelpdesk}}</i>
    </v-layout>
    <v-btn
      dark
      flat
      @click="genericErrorDialog = false"
    >
      {{$translate('CLOSE')}}
    </v-btn>
  </v-snackbar>
<!--  <v-dialog-->
<!--    width="450"-->
<!--    persistent-->
<!--    v-model="genericErrorDialog"-->
<!--  >-->
<!--    <v-card class="errorClass elevation-0">-->
<!--      <v-layout justify-center align-center column>-->

<!--        <v-card-text>-->
<!--          <v-layout justify-center align-center column>-->
<!--            <v-icon class="iconSize mb-4 mt-2" x-large>-->
<!--              error_outline-->
<!--            </v-icon>-->
<!--            <h3 class="mt-4"><i>{{errorMessage}}</i></h3>-->
<!--          </v-layout>-->
<!--        </v-card-text>-->
<!--        <v-divider></v-divider>-->
<!--      </v-layout>-->
<!--      <v-layout class="mt-4" justify-end align-center column>-->
<!--        <v-card-actions class="mt-4">-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-btn color="primary" @click="genericErrorDialog = false">{{$translate('CLOSE')}}</v-btn>-->
<!--        </v-card-actions>-->
<!--      </v-layout>-->
<!--    </v-card>-->
<!--  </v-dialog>-->
</template>


<script>
  import { store } from "@/store.js";
  import appConfig from "../../config/app_config";
  import * as dssRequest from "@/api/dssRequest";
  import { ui_helpers } from "../shared/ui_helpers";

  export default {
    name: "ErrorDialog",
    mixins: [ui_helpers],
    created() {
      window.EventBus.listen(
        "triggerGenericErrorDialog",
        this.triggerGenericErrorDialog);
    },
    beforeDestroy() {
      window.EventBus.removeListener(
        "triggerGenericErrorDialog",
        this.triggerGenericErrorDialog
      )
    },
    data() {
      return {
        genericErrorDialog: false,
        errorMessage: '',
        contactHelpdesk: '',
      };
    },
    mounted() {

    },
    methods: {
      triggerGenericErrorDialog(errorCode) {

        // Opens up the dialog and sets the correct error text
        this.genericErrorDialog = true;
        this.errorMessage = this.$translate(errorCode);
        this.contactHelpdesk = this.$translate('W_HELPDESK_001');

      }
    }
  };
</script>

<style scoped lang="scss">

  .iconSize {
    color: deepskyblue;
    transform: scale(1.4);
  }

  .errorClass {
    min-height: calc(30vh);
    border-radius: 10px;
    border: 2px solid deepskyblue !important;
  }
</style>
